// @flow
import React from "react";
import type {
  Team,
  Opponent,
  Location,
  Game,
  TicketReservationStatusType,
} from "../../common/types";
import GameDetailsContent from "./GameDetailsContent";
import dev from "../../common/dev";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import BackdropLoading from "../../components/BackdropLoading";
import { SuspenseWithPerf } from "reactfire";

type GameDetailsProps = {
  game: Game,
  team: Team,
  opponent: Opponent,
  location: Location,
  isMatchday?: boolean,
  ticketReservationStatus: TicketReservationStatusType,
};

type Props = GameDetailsProps & {
  open: boolean,
  setOpen: Function,
};

function GameDetails({ open, setOpen, ...other }: Props) {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      disableBackdropTransition={dev.isIos()}
      disableDiscovery={true}
      disableSwipeToOpen={true}
      variant="temporary"
    >
      <SuspenseWithPerf
        traceId="GameDetailsContent"
        fallback={<BackdropLoading />}
      >
        <GameDetailsContent {...other} />
      </SuspenseWithPerf>
    </SwipeableDrawer>
  );
}

export type { GameDetailsProps };

export default GameDetails;
